import { useMutation, useQueryClient } from "react-query";
import { useSnackbar } from "notistack";

import { PaymentType } from "../../models";
import { RQ } from "../../globals/enums";
import { remove } from "../../api/generic-api";
import { deleteEntity } from "../../utils";

export const useDeletePaymentType = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation((id: string) => remove("payment-types", id), {
    onSuccess: (_, id) => {
      enqueueSnackbar("Payment Type Deleted", { variant: "success" });
      queryClient.setQueryData(
        RQ.PAYMENT_TYPES,
        (paymentTypes: PaymentType[] | undefined) => {
          return !paymentTypes
            ? []
            : deleteEntity<PaymentType>(paymentTypes, "id", id);
        }
      );
    },
    onError: () => {
      enqueueSnackbar("Payment Type Deleting Error", { variant: "error" });
    },
  });
};
